<template>
  <div class="px-6">
    <!-- LOADING DATA -->
    <LoadingPage v-if="loading"></LoadingPage>
    <!-- COMPLETE VIEW -->
    <div v-else>
      <InfoCreatingClient
        v-if="selectedClient.stackstatus == 'CREATING'"
        :clientInfo="selectedClient"
      ></InfoCreatingClient>
      <div v-else>
        <ParkingList :parkingList="parkingList"></ParkingList>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingPage from "../components/common/LoadingPage.vue";
import InfoCreatingClient from "../components/common/InfoCreatingClient.vue";
import ParkingList from "../components/Parkings/ParkingList.vue";

export default {
  name: "Parkings",

  components: {
    LoadingPage,
    InfoCreatingClient,
    ParkingList,
  },

  created() {
    this.fetchParkings();
  },

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    selectedClient() {
      return this.$store.getters.selectedClient;
    },
    parkingList() {
      return this.$store.getters.parkings;
    },
  },

  watch: {
    selectedClient(nVal, oVal) {
      if (nVal.id !== oVal.id) {
        this.fetchParkings();
      }
    },
  },

  methods: {
    async fetchParkings() {
      this.loading = true;
      await this.$store.dispatch("fetch_parkings");
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
